import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createLabel,
  createProjectLabel,
  deleteLabel,
  listLabels,
  updateLabel,
  type LabelScope,
} from '../lib/labelsApi';

export function useLabels(scope?: LabelScope) {
  return useQuery({
    queryKey: scope ? ['labels', scope] : ['labels'],
    queryFn: () => listLabels(scope),
  });
}

export function useCreateLabel(scope?: LabelScope) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; color?: string }) =>
      createLabel(input.name, input.color, scope),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['labels'] });
    },
  });
}

// CLE-182: create a label scoped to a project (used by the task detail sidebar).
export function useCreateProjectLabel(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; color?: string }) =>
      createProjectLabel(projectId, input.name, input.color),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['labels'] });
    },
  });
}

export function useUpdateLabel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; name?: string; color?: string }) =>
      updateLabel(input.id, { name: input.name, color: input.color }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['labels'] });
    },
  });
}

export function useDeleteLabel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteLabel(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['labels'] });
      void qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}
